"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fieldPermissionMap = void 0;
const action_constants_1 = require("../../../../../shared/store/action_constants");
const immer_1 = __importDefault(require("immer"));
const fieldPermissionMap = (state = {}, action) => {
    switch (action.type) {
        case action_constants_1.UPDATE_FIELD_PERMISSION_MAP: {
            if (!state) {
                return action.payload;
            }
            return Object.assign(Object.assign({}, state), action.payload);
        }
        case action_constants_1.RESET_FIELD_PERMISSION_MAP: {
            return (0, immer_1.default)(state, draft => {
                if (draft[action.payload]) {
                    delete draft[action.payload];
                }
                return draft;
            });
        }
        case action_constants_1.LOAD_FIELD_PERMISSION_MAP: {
            return action.payload;
        }
        case action_constants_1.UPDATE_FIELD_PERMISSION_SETTING: {
            return (0, immer_1.default)(state, (draft) => {
                const { fieldId, setting } = action.payload;
                if (!draft || !draft[fieldId]) {
                    return draft;
                }
                draft[fieldId].setting = setting;
                return draft;
            });
        }
        default: {
            return state;
        }
    }
};
exports.fieldPermissionMap = fieldPermissionMap;
//# sourceMappingURL=field_permission_map.js.map